<template>
  <div>
    <div class="o-container o-container--full u-pad-top--4 u-mrgn-bottom--4">
      <div class="u-txt--medium u-mrgn-bottom--3">Bank Kustodian</div>
      <div class="u-txt--base u-line-height--20"><EllipsisText :line-num="7" :message="pageDescription" /></div>
    </div>

    <div><ProductList filter filter-mode="custodian_bank" /></div>

    <div><OtherLinkFooter :other-links="otherLinks" /></div>
  </div>
</template>

<script>
import ProductList from 'shared/components/mweb/ProductList';
import OtherLinkFooter from 'shared/components/mweb/OtherLinkFooter';
import EllipsisText from 'shared/components/Ellipsis/EllipsisText';

export default {
  name: 'CustodianBankIndexMobile',
  components: {
    ProductList,
    OtherLinkFooter,
    EllipsisText,
  },
  props: {
    otherLinks: {
      type: Array,
      default: () => [],
    },
    pageDescription: {
      type: String,
      default: '',
    },
  },
};
</script>
